export function getTomorrow() {
    return setTomorrow()
}

export function getTomorrowFormat() {
    return getDateFormat(setTomorrow())
}

const setTomorrow = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return new Date(today.setDate(today.getDate() + 1));
}

const getDateFormat = (date = new Date()) => {
    let day = ("0" + date.getDate()).slice(-2);
    let month = ("0" + (date.getMonth() + 1)).slice(-2);

    return date.getFullYear() + "-" + month + "-" + day;
}
